import React from 'react';
import { SaleMandateList } from '../components/mandates/SaleMandateList';

export function SaleMandatesPage() {
  return (
    <>
      <div className="page-header">
        <div>
          <div className="page-header-title">Verkaufsmandate</div>
          <div className="page-header-sub">Objekte im Verkaufsmandat</div>
        </div>
      </div>
      <div className="content">
        <SaleMandateList />
      </div>
    </>
  );
}
